export default __webpack_public_path__ + "static/media/laptop-icon.33cab8a5.svg";